export enum OptionBoxStatus {
  DEFAULT = 'default',
  SELECTED = 'selected',
  CORRECT = 'correct',
  INCORRECT = 'incorrect',
  DISABLED = 'disabled',
  COMPLETED = 'completed',
}
